export default "__VITE_PUBLIC_ASSET__00330172__"